/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */


import * as import0 from './app.component.scss.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from './layout/navigation.component.ngfactory';
import * as import3 from '../../../src/app/layout/navigation.component';
import * as import4 from '../../../src/app/shared/services/auth.service';
import * as import5 from '@angular/common';
import * as import6 from '@angular/router';
import * as import7 from '../../../src/app/shared/services/window-ref.service';
import * as import8 from '../../../src/app/shared/services/user.service';
import * as import9 from './home/home.component.ngfactory';
import * as import10 from '../../../src/app/home/home.component';
import * as import11 from '../../../src/app/app.component';
import * as import12 from '@angular/platform-browser';
const styles_AppComponent:any[] = [import0.styles];
export const RenderType_AppComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_AppComponent,
  data: {}
}
);
function View_AppComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'my-navigation-layout',([] as any[]),(null as any),(null as any),(null as any),import2.View_NavigationLayoutComponent_0,import2.RenderType_NavigationLayoutComponent)),
    import1.ɵdid(57344,(null as any),0,import3.NavigationLayoutComponent,[
      import4.AuthService,
      import5.Location,
      import6.Router,
      import7.WindowRefService,
      import8.UserService
    ]
    ,(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n  ']))
  ]
  ,(ck,v) => {
    ck(v,3,0);
  },(null as any));
}
function View_AppComponent_2(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'my-home',([] as any[]),(null as any),(null as any),(null as any),import9.View_HomeComponent_0,import9.RenderType_HomeComponent)),
    import1.ɵdid(57344,(null as any),0,import10.HomeComponent,[import4.AuthService],(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
function View_AppComponent_3(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'button',[[
        'ngClass',
        'scrollTop'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.scrollToTop(500)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(139264,(null as any),0,import5.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),[' '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-chevron-up'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any)))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'scrollTop';
    ck(v,1,0,currVal_0);
  },(null as any));
}
export function View_AppComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵted((null as any),['  '])),
    (l()(),import1.ɵand(8388608,(null as any),(null as any),1,(null as any),View_AppComponent_1)),
    import1.ɵdid(8192,(null as any),0,import5.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵand(8388608,(null as any),(null as any),1,(null as any),View_AppComponent_2)),
    import1.ɵdid(8192,(null as any),0,import5.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(8388608,(null as any),(null as any),1,'router-outlet',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import1.ɵdid(73728,(null as any),0,import6.RouterOutlet,[
      import6.RouterOutletMap,
      import1.ViewContainerRef,
      import1.ComponentFactoryResolver,
      [
        8,
        (null as any)
      ]

    ]
    ,(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵand(8388608,(null as any),(null as any),1,(null as any),View_AppComponent_3)),
    import1.ɵdid(8192,(null as any),0,import5.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n']))
  ]
  ,(ck,v) => {
    var co:import11.AppComponent = v.component;
    const currVal_0:any = co.detectUrl();
    ck(v,2,0,currVal_0);
    const currVal_1:boolean = (!co.authService.loggedin && co.authService.appLoader);
    ck(v,5,0,currVal_1);
    const currVal_2:any = co.showHide;
    ck(v,11,0,currVal_2);
  },(null as any));
}
function View_AppComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'my-app',([] as any[]),(null as any),[[
        'window',
        'scroll'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('window:scroll' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,1).doSomething($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },View_AppComponent_0,RenderType_AppComponent)),
    import1.ɵdid(57344,(null as any),0,import11.AppComponent,[
      import4.AuthService,
      import8.UserService,
      import5.Location,
      import7.WindowRefService,
      import12.Title
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const AppComponentNgFactory:import1.ComponentFactory<import11.AppComponent> = import1.ɵccf('my-app',import11.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy9zcmMvYXBwL2FwcC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vc3JjL3NyYy9hcHAvYXBwLmNvbXBvbmVudC50cyIsIm5nOi8vL3NyYy9zcmMvYXBwL2FwcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3NyYy9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiICA8ZGl2ICpuZ0lmPVwiZGV0ZWN0VXJsKClcIj5cbiAgICA8bXktbmF2aWdhdGlvbi1sYXlvdXQ+PC9teS1uYXZpZ2F0aW9uLWxheW91dD5cbiAgPC9kaXY+XG4gIDxteS1ob21lICpuZ0lmPVwiIWF1dGhTZXJ2aWNlLmxvZ2dlZGluICYmIGF1dGhTZXJ2aWNlLmFwcExvYWRlclwiPjwvbXktaG9tZT5cbiAgPHJvdXRlci1vdXRsZXQ+PC9yb3V0ZXItb3V0bGV0PlxuICA8YnV0dG9uICpuZ0lmPVwic2hvd0hpZGVcIiAoY2xpY2spPVwic2Nyb2xsVG9Ub3AoNTAwKVwiIG5nQ2xhc3M9XCJzY3JvbGxUb3BcIj4gPHNwYW4+PGkgY2xhc3M9XCJmYSBmYS1jaGV2cm9uLXVwXCIgYXJpYS1oaWRkZW49XCJ0cnVlXCI+PC9pPjwvc3Bhbj48L2J1dHRvbj5cblxuIiwiPG15LWFwcD48L215LWFwcD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUNBRTtJQUF5QjtJQUN2QjtnQkFBQTs7Ozs7O0lBQUE7S0FBQTtJQUE2Qzs7O0lBQTdDOzs7OztJQUVGO2dCQUFBOzs7SUFBQTs7Ozs7TUFFQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO01BQXlCO1FBQUE7UUFBQTtNQUFBO01BQXpCO0lBQUE7Z0JBQUE7Ozs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXdFO0lBQUM7SUFBTTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7OztJQUEzQjtJQUFwRCxTQUFvRCxTQUFwRDs7Ozs7SUFMRjtJQUFFO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFFTTtJQUNOO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBMEU7SUFDMUU7Z0JBQUE7Ozs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO0lBQStCO0lBQy9CO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBa0o7Ozs7SUFMN0k7SUFBTCxTQUFLLFNBQUw7SUFHUztJQUFULFNBQVMsU0FBVDtJQUVRO0lBQVIsVUFBUSxTQUFSOzs7OztNQ0xGO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7SUFBQTtnQkFBQTs7Ozs7O0lBQUE7S0FBQTs7O0lBQUE7OzsifQ==



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./compiled/src/app/app.component.ngfactory.ts